import { render } from "./MyProducts.vue?vue&type=template&id=752fb3f4&scoped=true"
import script from "./MyProducts.vue?vue&type=script&lang=js"
export * from "./MyProducts.vue?vue&type=script&lang=js"

import "./MyProducts.vue?vue&type=style&index=0&id=752fb3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752fb3f4"]])

export default __exports__